import { useState, useMemo } from "react";

const useLumpsumCalculator = () => {
    const [principal, setPrincipal] = useState(500000);
    const [rate, setRate] = useState(12);
    const [years, setYears] = useState(10);

    const totalValue = useMemo(() => {
        return principal * Math.pow(1 + rate / 100, years);
    }, [principal, rate, years]);

    const investedAmount = principal;

    return {
        title: "Lumpsum Calculator",

        inputs: [
            {
                label: "Investment Amount",
                value: principal,
                setter: setPrincipal,
                min: 10000,
                max: 10000000,
                step: 10000,
            },
            {
                label: "Expected Return Rate (p.a)",
                value: rate,
                setter: setRate,
                min: 1,
                max: 30,
                step: 0.5,
            },
            {
                label: "Time Period (Years)",
                value: years,
                setter: setYears,
                min: 1,
                max: 40,
                step: 1,
            },
        ],

        totalValue,
        investedAmount,
        estimatedReturns: totalValue - investedAmount,

        infoContent: {
            heading: "Lumpsum Calculator – One Time Investment",
            description:
                "A Lumpsum investment allows you to invest a large amount at once in a mutual fund or other financial instrument to generate long-term returns through compounding.",

            subHeading1: "What is a Lumpsum Calculator?",
            subContent1:
                "A Lumpsum calculator helps estimate the future value of a one-time investment based on expected annual returns and investment duration.",

            subHeading2: "How It Works",
            subContent2:
                "It uses the compound interest formula to calculate how your single investment grows over time at a fixed return rate.",

            formula: "M = P × (1 + r)^n",

            subHeading3: "Benefits",
            benefits: [
                "Helps estimate long-term wealth growth",
                "Useful for surplus or bonus funds",
                "Simple and quick calculation",
                "Supports goal-based planning",
            ],
        }
    };
};

export default useLumpsumCalculator;